import { IAddress } from 'models';

export const getFullLocationString = (address: IAddress | null | undefined, showZip = true) => {
  if (!address) {
    return '-';
  }

  let location = `${address.address_1}, ${address.city}, ${address.state}`;

  if (showZip) {
    location = `${location}, ${address.zip}`;
  }

  return location;
};
